import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';
import {
  NgcCookieConsentService,
  NgcInitializationErrorEvent,
  NgcInitializingEvent,
  NgcNoCookieLawEvent,
  NgcStatusChangeEvent
} from 'ngx-cookieconsent';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {

  // Gardez des références aux abonnements pour pouvoir vous désabonner plus tard
  private popupOpenSubscription!: Subscription;
  private popupCloseSubscription!: Subscription;
  private initializingSubscription!: Subscription;
  private initializedSubscription!: Subscription;
  private initializationErrorSubscription!: Subscription;
  private statusChangeSubscription!: Subscription;
  private revokeChoiceSubscription!: Subscription;
  private noCookieLawSubscription!: Subscription;


  constructor(private router: Router,
              private translate: TranslateService,
              private ccService: NgcCookieConsentService) { }

  ngOnInit() {
    // abonnez-vous aux observables cookieconsent pour réagir aux principaux événements
    this.popupOpenSubscription = this.ccService.popupOpen$.subscribe(
      () => {
        // vous pouvez utiliser this.ccService.getConfig() pour faire des choses...
      });

    this.popupCloseSubscription = this.ccService.popupClose$.subscribe(
      () => {
        // vous pouvez utiliser this.ccService.getConfig() pour faire des choses...
      });

    this.initializingSubscription = this.ccService.initializing$.subscribe(
      (event: NgcInitializingEvent) => {
        // le cookieconsent est en cours d'initialisation...
        // Pas encore sûr d'appeler des méthodes comme `NgcCookieConsentService.hasAnswered()`
        console.log(`initializing: ${JSON.stringify(event)}`);
      });

    this.initializedSubscription = this.ccService.initialized$.subscribe(
      () => {
        // le cookieconsent a été initialisé avec succès.
        // Il est maintenant sûr d'utiliser des méthodes sur
        // NgcCookieConsentService qui le nécessitent, comme `hasAnswered()` par exemple...
        console.log(`initialized: ${JSON.stringify(event)}`);
      });

    this.initializationErrorSubscription = this.ccService.initializationError$.subscribe(
      (event: NgcInitializationErrorEvent) => {
        // le cookieconsent n'a pas réussi à s'initialiser...
        console.log(`initializationError: ${JSON.stringify(event.error?.message)}`);
      });

    this.statusChangeSubscription = this.ccService.statusChange$.subscribe(
      (event: NgcStatusChangeEvent) => {
        // vous pouvez utiliser this.ccService.getConfig() pour faire des choses...
      });

    this.revokeChoiceSubscription = this.ccService.revokeChoice$.subscribe(
      () => {
        // vous pouvez utiliser this.ccService.getConfig() pour faire des choses...
      });

    this.noCookieLawSubscription = this.ccService.noCookieLaw$.subscribe(
      (event: NgcNoCookieLawEvent) => {
        // vous pouvez utiliser this.ccService.getConfig() pour faire des choses...
      });
  }

  navigate(path: string) {
    this.router.navigate(['/' + path]);
  }

  navigateToAnchor(path: string, anchor: string) {
    this.router.navigate(['/' + path], { fragment: anchor });

  }

  useLanguage(language: string) {
    this.translate.use(language);
  }


  ngOnDestroy() {
    // désabonnez-vous des observables cookieconsent pour éviter les fuites de mémoire
    this.popupOpenSubscription.unsubscribe();
    this.popupCloseSubscription.unsubscribe();
    this.initializingSubscription.unsubscribe();
    this.initializedSubscription.unsubscribe();
    this.initializationErrorSubscription.unsubscribe();
    this.statusChangeSubscription.unsubscribe();
    this.revokeChoiceSubscription.unsubscribe();
    this.noCookieLawSubscription.unsubscribe();
  }

}
